let EVENT_TYPES = {
  appointment_bookings_state_update: 'Appointment Status',
  txs_status_update: 'Treatment Status',
  custom_resource_insert: 'Custom Resource Created',
}

export function getTitle(event_type) {
  return `Automate ${EVENT_TYPES[event_type] ?? ''} workflow`
}
